import './polyfills';

import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

import * as serviceWorkerRegistration from './serviceWorkerRegistration';

ReactDOM.render(
  // <React.StrictMode>
  <App />,
  // </React.StrictMode>,
  document.getElementById('app-root')
);

/**
 * PWA: habilita a instalação do CDI na tela inicial do celular.
 *
 * O service worker (public/sw.js) só coloca em cache asset estático da
 * aplicação — nenhuma chamada de API e nenhum desenho de catálogo.
 * O registro acontece apenas em produção e sob HTTPS.
 *
 * Para desativar o PWA, troque register() por
 * serviceWorkerRegistration.unregister(): isso remove o service worker e
 * limpa os caches também de quem já tinha o app instalado.
 */
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    /**
     * Nova versão publicada e já baixada. A ativação padrão acontece no
     * próximo carregamento; para aplicar na hora, chame
     * serviceWorkerRegistration.applyUpdate(registration) — por exemplo
     * a partir de um aviso na interface.
     */
    if (process.env.NODE_ENV !== 'production') {
      console.info('[CDI] nova versão disponível', registration);
    }
  },
});
